import { useContext } from 'react';

import { SystemStatusContext } from '../../providers/systemStatusProvider';
import { systemStatusTypes } from '@twiliointernal/e2-commons-shared-ui';

function useSystemStatus(): systemStatusTypes.SystemStatusProps {
  return useContext(SystemStatusContext);
}

export default useSystemStatus;
